exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quantity-control[data-v-67ef3dd6]{\n  color: gray;\n  border: 1px solid gray;\n  padding: 4px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  font-size: 9px;\n  margin: 0px 10px;\n}\n.quantity-controls a[data-v-67ef3dd6],\n.quantity-controls a[data-v-67ef3dd6]:hover,\n.quantity-controls a[data-v-67ef3dd6]:focus {\n  text-decoration: none;\n  transition: all 0.3s;\n  cursor: pointer;\n}\n", ""]);

// exports
